<template>
  <div class="tempus-iframe-locked-container pre-cart">
    <div class="container">
      <div class="row py-4">
        <div class="col">

          <h3 class="font-weight-bold" :class="$deploymentIs('cryptology') ? 'font-mon' : ''" :style="$deploymentIn(['breakescape', 'taketheexit']) ? 'letter-spacing: 0;' : ''">{{ location.brand }} Room Booking Locked</h3>

          <h3 class="mb-2">
            This slot is currently reserved for {{ slotLockLength }} as somebody is trying to book it.
          </h3>
          <h4 class="mb-2">
            If this is you, enter your email to continue with your booking.
          </h4>
          <h4 class="mb-2">
            If you wish to unlock this and make it available again, enter your email and click <span class="tempus-iframe-text-warning">Destroy Lock &amp; Make Available</span>
          </h4>
        </div>
      </div>

      <div class="alert alert-blue tempus-iframe-form" role="alert">
        <p><strong>Is this you?</strong> Enter your email address to continue or remove the lock to change the booking</p>
        <div class="input-group input-group-lg">
          <div class="input-group-prepend">
            <span class="input-group-text" for="lockEmailAddon">@</span>
          </div>
          <input
            type="email"
            class="form-control"
            placeholder="Email address"
            v-model="lockEmail"
            aria-label="Email address"
            aria-describedby="lockEmailAddon">
        </div>
      </div>

      <div class="alert alert-red" role="alert" v-if="lockError">
        <h4><span class="material-icons md-72 text-red">error</span> {{ lockError }}</h4>
      </div>

      <div class="row py-4">
        <div class="col btn-group">
          <button type="button" class="btn btn-lg btn-danger" @click="destroyRoomSlotLock">
            Destroy Lock & Make Available <span class="material-icons" style="position: relative; top: 5px;">no_encryption</span>
          </button>
          <button type="button" class="btn btn-lg btn-primary" @click="lockProceed">
            Proceed To Payment <span class="material-icons" style="position: relative; top: 5px;">add_shopping_cart</span>
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    consoleDebug: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
    lockedRoomSlot: {
      type: Object,
    },
  },

  data() {
    return {
      lockError: false,
      lockEmail: null,
    };
  },

  watch: {

  },

  computed: {
    slotLockLength() {
      if (this.lockedRoomSlot
          && ('LOCKED' == this.lockedRoomSlot.state || 'BOOKED_PENDING' == this.lockedRoomSlot.state)
          && this.lockedRoomSlot.activeRoomSlotLock) {
        return moment.duration(
          moment(this.lockedRoomSlot.activeRoomSlotLock.expires_at).diff(moment())
          ).humanize();
      }

      return 'some minutes';
    },
  },

  methods: {
    populateLockError(lockError) {
      this.lockError = lockError;
    },

    destroyRoomSlotLock() {
      if (this.consoleDebug) console.log('BookingCheckoutIframeUnlockLockedRoomSlot::destroyRoomSlotLock');
      this.lockError = null;

      if (! this.lockEmail) {
        flash('You must enter an email', 'danger');
        return false;
      }

      this.$emit('destroy-room-slot-lock', {email: this.lockEmail, roomSlot: this.lockedRoomSlot});
    },

    lockProceed() {
      if (this.consoleDebug) console.log('BookingCheckoutIframeUnlockLockedRoomSlot::lockProceed');
      this.lockError = null;

      if (! this.lockEmail) {
        flash('You must enter an email', 'danger');
        return false;
      }

      this.$emit('proceed-to-sale-from-locked-room-slot', {email: this.lockEmail, roomSlot: this.lockedRoomSlot});
    }
  },

  mounted() {

  },
}
</script>
